// A busca identifica a pessoa em `id`; a seleção operacional usa o contrato.
export const getContratoProfissionalId = (profissional = {}) =>
	Number(
		profissional.vinculo_profissional_id ||
			profissional.vinculo_estabelecimento_id ||
			profissional.vinculo_id ||
			profissional.vinculoId ||
			0,
	) || null;

export const getContratoRotulo = (profissional = {}) => {
	if (profissional.rotulo) return profissional.rotulo;
	const id = getContratoProfissionalId(profissional);
	const tipo = profissional.nome_vinculo || profissional.nomeVinculo || 'Vínculo';
	const regime = profissional.regime_institucional?.rotulo || 'Regime não informado';
	return id ? `${tipo} — ${regime} — contrato ${id}` : 'Cadastro consultado no CNES';
};

export const selecionarContratoBusca = (resultados = [], contratoAtualId = null) => {
	if (!Array.isArray(resultados)) return null;
	if (contratoAtualId) {
		return resultados.find(
			(item) => getContratoProfissionalId(item) === Number(contratoAtualId),
		) || null;
	}
	return resultados.length === 1 ? resultados[0] : null;
};

export const getContratoVinculoTipoId = (profissional = {}) =>
	Number(
		profissional.tipo_vinculo_id ||
			profissional.vinculo_tipo_id ||
			profissional.vinculoTipoId ||
			profissional.vinculo_tipo?.id ||
			profissional.vinculo?.id ||
			profissional.tipo_vinculo?.id ||
			0,
	) || null;

export const selecionarContratoAutomatico = (
	resultados = [],
	{ contratoAtualId = null, vinculoTipoId = null } = {},
) => {
	if (!Array.isArray(resultados) || !resultados.length) return null;
	if (contratoAtualId) {
		const contratoAtual = resultados.find(
			(item) => getContratoProfissionalId(item) === Number(contratoAtualId),
		);
		if (contratoAtual) return contratoAtual;
	}
	if (vinculoTipoId) {
		const mesmoVinculo = resultados.find(
			(item) => getContratoVinculoTipoId(item) === Number(vinculoTipoId),
		);
		if (mesmoVinculo) return mesmoVinculo;
	}
	return resultados[0];
};

export const deveCriarNovoVinculoAutomaticamente = (
	contratoAtual = null,
	vinculoTipoId = null,
	jaEstaCriandoNovoVinculo = false,
) =>
	Boolean(
		Number(vinculoTipoId || 0) &&
			(jaEstaCriandoNovoVinculo ||
				(Boolean(getContratoProfissionalId(contratoAtual || {})) &&
					getContratoVinculoTipoId(contratoAtual || {}) !==
						Number(vinculoTipoId))),
	);

export const getContratoEdicaoId = (item = {}, formulario = {}) => {
	const fontes = [item, item?.dados_edicao, item?.edicao, formulario?.item, formulario?.defaults, formulario];
	for (const fonte of fontes) {
		const id = getContratoProfissionalId(fonte || {}) ||
			getContratoProfissionalId(fonte?.profissional || {}) ||
			getContratoProfissionalId(fonte?.profissional_por_cpf || {}) ||
			getContratoProfissionalId(fonte?.edicao?.profissional_por_cpf || {}) ||
			Number(fonte?.vinculo_profissional?.id || 0);
		if (id) return id;
	}
	return null;
};

export const selecionarContratoEdicao = (resultados, item, formulario) => {
	const id = getContratoEdicaoId(item, formulario);
	return id ? selecionarContratoBusca(resultados, id) : null;
};

// Campos exclusivos do comando de cadastro. Regime da linha nunca entra aqui.
export const buildIntencaoContrato = (contratoId, novoContrato = {}) => {
	if (!novoContrato.enabled) return contratoId ? { vinculo_profissional_id: Number(contratoId) } : {};
	return {
		criar_novo_vinculo: true,
		cargo: novoContrato.cargo || '',
		telefone: String(novoContrato.telefone || '').replace(/\D/g, ''),
		...(novoContrato.carga_horaria_semanal !== '' && novoContrato.carga_horaria_semanal != null
			? { carga_horaria_semanal: Number(novoContrato.carga_horaria_semanal) }
			: {}),
		regime_institucional: {
			regime: novoContrato.regime,
			vigencia_inicio: novoContrato.vigencia_inicio,
			vigencia_fim: novoContrato.vigencia_fim || null,
		},
	};
};
